import { render, staticRenderFns } from "./MST_MGMT_TRGTS.vue?vue&type=template&id=173381b3&scoped=true"
import script from "./MST_MGMT_TRGTS.vue?vue&type=script&lang=ts"
export * from "./MST_MGMT_TRGTS.vue?vue&type=script&lang=ts"
import style0 from "./MST_MGMT_TRGTS.vue?vue&type=style&index=0&id=173381b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173381b3",
  null
  
)

export default component.exports